import { IonInput } from "@ionic/react";
import React, { useCallback, useRef, useState } from "react";
import ReactTooltip from 'react-tooltip';
import './NumericInput.css';

interface NumericInputProps {
    value: number,
    min: number|null,
    max: number|null,
    onValueChange: (value:number) => void
};

const isValueInRange = (value :number, min: number|null, max: number|null) => {
    return (!min || value >= min) && (!max || value <= max);
};

const NumericInput : React.FC<NumericInputProps> = (props) => {
    const [strValue, setStrValue] = useState<string>(props.value.toString());

    const strNumber = Number(strValue.replace(',', '.'));
    if (!isNaN(strNumber) && props.value !== strNumber) {
        setStrValue(props.value.toString());
    }

    let isValidValue = isValueInRange(props.value, props.min, props.max);
    let errorMsg = (props.min ? `Min = ${props.min} ` : '')
                 + (props.max && props.min ? '<br/>' : '')
                 + (props.max ? `Max = ${props.max} ` : '');

    let tooltipRef = useRef<HTMLIonInputElement | null>(null);

    const onKeyDown =  (e:any) => {
        var keyCode = e.keyCode || e.which;

        const CONTROL_CODES = [8, 37, 38, 39, 40];
        const isControl = CONTROL_CODES.findIndex(k => k === keyCode) !== -1;
        if (isControl)
            return;

        const NUMERIC_CODES = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
        const isNumeric = NUMERIC_CODES.findIndex(k => k === keyCode) !== -1;
        if (isNumeric)
            return;
        
        let isDot = keyCode === 188;
        let isComma = keyCode === 190;
        if (isDot || isComma)
        {
            let hasDecimal:boolean = strValue.indexOf('.') !== -1 || strValue.indexOf(',') !== -1;
            if (!hasDecimal)
                return;
        }
        
        e.preventDefault();
    };

    const onValueChange = useCallback(
        (value:string) => {
            let newNumericValue:number = Number(value.replace(',', '.'));
            if (newNumericValue !== props.value)
                props.onValueChange(newNumericValue);

            if (tooltipRef.current) {
                let isValid = isValueInRange(newNumericValue, props.min, props.max);
                if (isValid)
                    ReactTooltip.hide(tooltipRef.current);
                else
                    ReactTooltip.show(tooltipRef.current);
            }

            setStrValue(value);
        }, [props, setStrValue]
    );

    const onFocus = useCallback(
        () => {
            let isValid = isValueInRange(props.value, props.min, props.max);
            if (tooltipRef.current && !isValid)
                ReactTooltip.show(tooltipRef.current);
        }, [props]
    );

    const onBlur = useCallback(
        () => {
            if (tooltipRef.current)
                ReactTooltip.hide(tooltipRef.current);
        }, []
    );

    return (
        <IonInput
            ref={tooltipRef}
            data-type="error"
            data-tip={errorMsg}
            data-place="bottom"
            data-event="custom"
            data-html={true}
            data-class=".tooltipnumericinput"
            type="text"
            value={strValue}
            onKeyDown={(e) => onKeyDown(e)}
            onIonChange={e => onValueChange(e.detail.value || "")}
            onFocus={onFocus}
            onBlur={onBlur}
            inputmode="decimal"
            placeholder={props.min?.toString()}
            className={"numericInput" + (isValidValue ? '' : ' invalidInput')}
        />
    )
};

export default NumericInput;